import React from "react";
import { RemoveBaseUrl } from "utils";
import {
  NavMenuWrapper,
  LogoContainer,
  Logo,
  NavMenuContainer,
  Menu,
  MenuItem,
  SocialIcons,
} from "./styles/NavMenuStyles";

// Real links (new tab, keyboard), while a plain click stays in the app.
const appLink = (navigateTo, path, baseRemoved) => (e) => {
  if (e.metaKey || e.ctrlKey || e.shiftKey) return;
  e.preventDefault();
  navigateTo(path, baseRemoved);
};

const NavMenu = ({ data, navigateTo }) => {
  const { logo, menuItems, socials } = data;
  return (
    <NavMenuWrapper className="NavMenu">
      <LogoContainer href="/" onClick={appLink(navigateTo, "/")}>
        {logo && <Logo src={logo} alt="Institut Amadeus" />}
      </LogoContainer>
      <NavMenuContainer>
        <Menu>
          {menuItems &&
            menuItems.map((menu, i) => {
              const path = RemoveBaseUrl(menu.url);
              return (
                <MenuItem
                  key={i}
                  href={path}
                  onClick={appLink(navigateTo, path, true)}
                >
                  {menu.label}
                </MenuItem>
              );
            })}
        </Menu>
        <SocialIcons>
          {socials &&
            socials.map((item, i) => (
              <a
                href={item.lien}
                key={i}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={item.plateforme}
              >
                <img src={item.icone.sourceUrl} alt="" />
              </a>
            ))}
        </SocialIcons>
      </NavMenuContainer>
    </NavMenuWrapper>
  );
};

export default NavMenu;
